import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

cssRule('.tb-device-preview-button-container', {
    float: 'right',
    marginTop: '7px',
    marginRight: '24px',
});

cssRule('.tb-device-picker-bar', {
    fontWeight: 'normal',
});

cssRule('.tb-device-picker-bar .tab-preview-tools-container', {
    display: 'flex',
});

cssRule('.tb-device-picker-bar .tab-preview-tools-container .tab-left-spacer', {
    flex: 1,
});

cssRule('.tb-device-picker-bar .tab-preview-tools-container .tab-device-bar', {
    flex: '0 0 auto',
    display: 'flex',
});

cssRule('.tb-device-picker-bar .tab-preview-tools-container .tab-right-spacer', {
    flex: 1,
    display: 'flex',
});

cssRule('.tb-device-picker-bar .tab-preview-tools-container .tab-right-spacer .tab-collapsible-margin', {
    flex: '0 1 70px',
});

cssRule('.tb-device-picker-bar .tab-device-icon', {
    paddingLeft: '12px',
    paddingRight: '12px',
});

cssRule('.tb-device-picker-bar .dark > button.outline', {
    borderColor: applyColor(DesignTokens.color.mode_agnostic.default.neutral90, CommonStyles.Colors.Grey230),
    color: applyColor(DesignTokens.color.mode_agnostic.default.neutral90, CommonStyles.Colors.Grey230),
});

cssRule('.tb-device-picker-bar .dark label', {
    color: applyColor(DesignTokens.color.mode_agnostic.default.neutral90, CommonStyles.Colors.Grey230),
});

cssRule('[data-tb-test-id="device-preview-close-Button"]:hover:enabled', {
    backgroundColor: applyColor(DesignTokens.color.mode_agnostic.default.neutral30, '#444444'),
});

cssRule('.tb-device-viz-preview-fill', {
    background: applyColor(DesignTokens.color.mode_agnostic.default.neutral20, '#282828'),
    top: '65px',
});

cssRule('.tb-viz-preview-viewer.tb-vizviewer', {
    border: 'none',
});

cssRule('.tb-viz-preview-viewer.tb-vizviewer.tb-viz-with-breadcrumb-bar', {
    bottom: 0,
});

cssRule('.tb-preview-title-box h1', {
    color: applyColor(DesignTokens.color.mode_agnostic.default.neutral90, CommonStyles.Colors.Grey230),
    display: 'inline',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '18px',
    height: 'auto',
    width: 'auto',
    marginBlock: 0,
    marginInline: 0,
});

